import { createSelector } from '@reduxjs/toolkit'
import type { ArticleStateLayoutable } from './types'

export const selectArticlesLayoutable = (state: { article: { layoutable: ArticleStateLayoutable | null } }) =>
  state?.article?.layoutable

export const selectArticle = (state: { article: unknown }) => state.article

export const selectLayoutableTitleWithMargin = createSelector(
  selectArticlesLayoutable,
  (layoutable: ArticleStateLayoutable | null) => {
    if (!layoutable) return null
    const labels = (
      layoutable.pageMarginOtherSelections as
        Array<{ pageMarginOtherSettingName?: string; pageMarginSettingName?: string }> | undefined
    )
      ?.filter((s) => s.pageMarginOtherSettingName && s.pageMarginSettingName)
      ?.map((s) => `${s.pageMarginOtherSettingName}:${s.pageMarginSettingName}`)
    const suffix = labels && labels.length > 0 ? `（${labels.join('、')}）` : ''
    return `${layoutable.name}${suffix}`
  }
)

// 欄外（pageMarginOtherSelections）の表示文字列のみを返す。欄外がない場合は空文字列。
export const selectLayoutableTitleSuffix = createSelector(
  selectArticlesLayoutable,
  (layoutable: ArticleStateLayoutable | null): string => {
    if (!layoutable) return ''
    const labels = (
      layoutable.pageMarginOtherSelections as
        Array<{ pageMarginOtherSettingName?: string; pageMarginSettingName?: string }> | undefined
    )
      ?.filter((s) => s.pageMarginOtherSettingName && s.pageMarginSettingName)
      ?.map((s) => `${s.pageMarginOtherSettingName}:${s.pageMarginSettingName}`)
    return labels && labels.length > 0 ? `（${labels.join('、')}）` : ''
  }
)
